import { useEffect, useState, useRef } from "react";
import { getToken, getUserId,getInizioPeriodo,getFinePeriodo } from "../../../auth";
import funzione_collegamento from "../../../funzioni_server/pacchetti_lez_function.js";
import  differenzaOrario  from "../../../funzioni/differenza_ore";
import "../../../stili/tabelle.css";
import "../../../stili/popup.css";
import "../../../stili/tabs.css"
import convertDate from "../../../funzioni/converti_data";
import { DateTime } from 'luxon';
import nome_id from "../../../funzioni/nome_id.js"
import {convertiIdNoleggio,convertiValuta,convertiIdInventario,materialeDisponibile,analisiMateriale,sovrapposti,ordinaPerData,convertiTipoStorage} from "../../../funzioni/funzioni_utili"
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUsers, faPencil, faTrashCan,faCircleInfo,faSpinner } from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import animLoading from "../../../assets/loading.json";
import {noleggi_off,utenti_off} from "../../../offline/offline_costanti.js";
/* global $ */
function SpeseStorico() {
const inizioP=DateTime.fromISO(getInizioPeriodo()).toFormat("yyyyMMdd")
const fineP=DateTime.fromISO(getFinePeriodo()).plus({days:1}).toFormat("yyyyMMdd")
let modificheCategorie = {
  aggiunti: [],
  eliminati: [],
  modificati: [],
};
let modificheSottoCategorie = {
  aggiunti: [],
  eliminati: [],
  modificati: [],
};
function modificaLista(lista,aggiunta,valore,eliminazione,cellInfo,nomeBox,cellElement) {
    let nomeTit=null
    const dataGrid= $("#gridContainerSpese").dxDataGrid("instance");
    let ambito=""
    if (nomeBox==="val_categoria"){
        nomeTit=cellInfo.data.categoria
        ambito="categoria"
    }
    else{
        nomeTit=cellInfo.data.sottocategoria
        ambito="sottocategoria"
    }
    const contenuto =document.createElement("div")
    contenuto.style.padding = "0px";
    if (!eliminazione){
    contenuto.id="textboxmodifica"
    setTimeout(() => {
        $("#textboxmodifica").dxTextBox({label:aggiunta ? `Aggiungi ${ambito}`: `Modifica ${ambito}`,value: aggiunta ? null : valore

        })
    },0)}
    else {
        contenuto.innerText = `Sei sicuro di volere eliminare la ${ambito}?`
        contenuto.style.marginTop = "10px";
        contenuto.style.fontWeight = "bold";
        contenuto.style.fontSize = "20px";
        contenuto.style.fontFamily = "Poppins, sans-serif";

    }
    $("#modificaListaNomi").dxPopup("instance").option( "title",eliminazione? `Conferma eliminazione della ${ambito}` : aggiunta ? `Aggiungi ${ambito}` : `Modifica ${ambito}`);
    $("#modificaListaNomi").dxPopup("instance").option("contentTemplate", () => contenuto);
    $("#modificaListaNomi").dxPopup("instance").option( "toolbarItems", [{
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'before',

      options: {
        stylingMode: 'contained',
        text: 'Salva',
        onClick: async function() { $("#modificaListaNomi").dxPopup("instance").hide();
            if (aggiunta) {
                let datas=($(`#${nomeBox}`).dxSelectBox("instance").option("dataSource"))
                let dati_n=[]
                let idNuovo=0
                console.log(ambito)
                if (ambito==="categoria"){
                     dati_n={"registrytypecategory":1,'registrytypedescr':$("#textboxmodifica").dxTextBox("instance").option("value")}
                        let richiesta = await funzione_collegamento({
                       userid: getUserId(),
                        token: getToken(),
                        logout_on_error: true,
                        valori:dati_n,
                        azione:'setRegistryType'})
                    idNuovo=richiesta.registrytypeid
                }
                else{
                    dati_n={"registrytypecategory": 1,'registrytypeid':$(`#val_categoria`).dxSelectBox("instance").option("value"),'registrysubtypedescr':$("#textboxmodifica").dxTextBox("instance").option("value")}
                        let richiesta = await funzione_collegamento({
                       userid: getUserId(),
                        token: getToken(),
                        logout_on_error: true,
                        valori:dati_n,
                        azione:'setRegistrySubType'})
                    idNuovo=richiesta.registrysubtypeid
                }
                let nomeColonna = ambito === "categoria" ? "categoria" : "sottocategoria";
                dataGrid.cellValue(cellInfo.rowIndex, nomeColonna, $("#textboxmodifica").dxTextBox("instance").option("value"));
                let vecchioD = $(`#${nomeBox}`).dxSelectBox("instance").option("dataSource");
                let valoreTextbox = $("#textboxmodifica").dxTextBox("instance").option("value");

                let nuovoElemento = {
                  ID: idNuovo,
                  name: valoreTextbox
                };

                if (ambito === "sottocategoria") {
                  nuovoElemento.idCat = $(`#val_categoria`).dxSelectBox("instance").option("value");
                }

                vecchioD = [...vecchioD, nuovoElemento];
                $(`#${nomeBox}`).dxSelectBox("instance").option("dataSource", vecchioD);



            }
            else {
                if (!eliminazione) {
                    let lista=($(`#${nomeBox}`).dxSelectBox("instance").option("dataSource"))
                    let elemento = lista.find(obj => obj.ID === ($(`#${nomeBox}`).dxSelectBox("instance").option("value")));
                    if (elemento) {
                      elemento.ID = $(`#${nomeBox}`).dxSelectBox("instance").option("value")
                      elemento.name = $("#textboxmodifica").dxTextBox("instance").option("value");
                      $(`#${nomeBox}`).dxSelectBox("instance").option("dataSource",lista)
                      if (ambito==="categoria")
                      {modificheCategorie["modificati"]=[...modificheCategorie["modificati"],elemento]
                      dataGrid.cellValue(cellInfo.rowIndex, "categoria",    "suca")}
                      else
                      {modificheSottoCategorie["modificati"]=[...modificheSottoCategorie["modificati"],elemento]
                      dataGrid.cellValue(cellInfo.rowIndex, "sottocategoria",    $("#textboxmodifica").dxTextBox("instance").option("value"))}

                    }
                }
                else {
                    let lista=($(`#${nomeBox}`).dxSelectBox("instance").option("dataSource"))
                    let elemento = lista.find(obj => obj.ID === ($(`#${nomeBox}`).dxSelectBox("instance").option("value")));

                    if (elemento) {
                        const indice=lista.indexOf(elemento)
                        lista.splice(indice,1)
                         if (ambito==="categoria"){
                        modificheCategorie["eliminati"]=[...modificheCategorie["eliminati"],elemento]
                        dataGrid.cellValue(cellInfo.rowIndex, "categoria",    "ciccio")}
                        else{
                         modificheSottoCategorie["eliminati"]=[...modificheSottoCategorie["eliminati"],elemento]
                         dataGrid.cellValue(cellInfo.rowIndex, "sottocategoria",    "")}
                        $(`#${nomeBox}`).dxSelectBox("instance").option("dataSource",lista)

                    }
                }
            }
        },
      },
    }, {
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        text: 'Chiudi',
        stylingMode: 'outlined',
        type: 'normal',
        onClick() {
          $("#modificaListaNomi").dxPopup("instance").hide();

        },
      },
    }],)
    $("#modificaListaNomi").dxPopup("instance").show();

}
function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);


  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}
function TabellaStoricoSpese() {
    const allineamento="center"
    useEffect(() => {
        const fetchStorages = async () => {
            $("#gridContainerSpese").addClass("grid-container-hidden")
            $("#loadingOverlay").show()
            const datiTipi = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getRegistryTypes",
            })
            const datiSotto = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getRegistrySubtypes",
            })
            const dati = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                filtri:{"transactionsfrom":inizioP,"transactionsto":fineP},
                azione: "getTransactions",
            })
            let speseScuola=[]
            let categorie=[]
           let sottocategorie=[]
           for (let categoria of datiTipi){
            if (categoria.registrytypecategory===1){
                categorie=[...categorie,{ID:categoria.registrytypeid,name:categoria.registrytypedescr}]
            }
           }
            for (let categoria of datiSotto){
            if (categoria.registrytypecategory===1){
                sottocategorie=[...sottocategorie,{ID:categoria.registrysubtypeid,name:categoria.registrysubtypedescr,idCat:categoria.registrytypeid}]
            }
           }
            for (let spesa of dati){
                if (spesa.transactionambit===0){
                    speseScuola=[...speseScuola,{idC:spesa.registrytypeid,idS:spesa.registrysubtypeid,id:spesa.transactionid,data:convertDate(spesa.transactiondate).toISO({includeOffset:false}),
                    categoria:spesa.registrytypedescr,sottocategoria:spesa.registrysubtypedescr,valore:spesa.transactionvalue,valuta:spesa.transactioncurrency,note:spesa.transactionnotes,
                    categories:JSON.stringify(categorie),subcategories:JSON.stringify(sottocategorie)
                    }]
                }
            }

            $("#gridContainerSpese").dxDataGrid({

          dataSource: speseScuola,
        columns: [
          {
            dataField: "data",
            caption: "Data",
            sortOrder: "desc",
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_reg").length===0) {
                $('<div id="val_reg"></div>').appendTo(cellElement)
            }
            $("#val_reg").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value, onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          },
            hidingPriority: 7,
            filterOperations: ["between", "=", "<", ">"],
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value,).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },
          { dataField: "idC", caption: "Categoria Spesa", hidingPriority: 12,alignment:allineamento,
          calculateDisplayValue: function(rowData) {
    return  rowData.categoria},
           editCellTemplate: function(cellElement,cellInfo){
           if ($("#val_categoria").length===0) {
                $('<div id="val_categoria"></div>').appendTo(cellElement)
            }
            $("#val_categoria").dxSelectBox({
                dataSource: categorie,
                valueExpr: 'ID', // Utilizza "id" per identificare un elemento
                displayExpr: 'name', // Mostra il "text" dell'elemento nella lista
                showClearButton: true,
                value:cellInfo.value,
                searchEnabled:true,
                onValueChanged: function(e) {
                cellInfo.setValue(e.value)
                let sottoCatId=[]
                for (let cat of sottocategorie){
                    if (cat.idCat===e.value){
                        sottoCatId=[...sottoCatId,cat]
                    }
                }
                $("#val_sottocategoria").dxSelectBox("instance").option("dataSource",sottoCatId)
                },
                buttons: [{
                  name: 'modifica',
                  location: 'after',
                  options: {
                    width: 20,
                    template: function () {
                        return $("<i class='fa-solid fa-pencil'></i>");
                    },
                    onClick(e) {
                      if ($("#val_categoria").dxSelectBox("instance").option("value")){
                      var indice=""
                      for (let i of categorie){
                        if (i.ID===$("#val_categoria").dxSelectBox("instance").option("value")) {indice = i.name}
                      }
                      modificaLista(categorie,false,indice,false,cellInfo,"val_categoria",cellElement)} else {
                      const message = `Seleziona un nome per poter modificare!`;
                        window.DevExpress.ui.notify({message,
                        position: {
                          my: 'center',
                          at: 'center',
                          of: '#gridContainerSpese',

                        },}, "error", 1000);
                      }
                    },
                  },
                },
                {
                  name: 'aggiungi',
                  location: 'after',
                  options: {
                    width: 20,
                    template: function () {
                        return $("<i class='fa-solid fa-plus'></i>");
                    },
                    onClick(e) {
                      modificaLista(categorie,true,0,false,cellInfo,"val_categoria",cellElement)
                    },
                  },
                },
                {
                  name: 'elimina',
                  location: 'after',
                  options: {
                    width: 20,
                    template: function () {

                        return $("<i class='fa-solid fa-trash-can'></i>");
                    },
                    onClick(e) {
                      if ($("#val_categoria").dxSelectBox("instance").option("value")){
                        var indice=0
                      var contatore=0
                      for (let i of categorie){
                        if (i.ID===$("#val_categoria").dxSelectBox("instance").option("value")) {indice = contatore}
                        contatore+=1
                      }
                      modificaLista(categorie,false,indice,true,cellInfo,"val_categoria",cellElement)
                      } else
                      {
                        const message = `Seleziona un nome per poter eliminare!`;
                        window.DevExpress.ui.notify({message,
                        position: {
                          my: 'center',
                          at: 'center',
                          of: '#gridContainerSpese',

                        },}, "error", 1000);
                      }
                    },
                  },
                },
                ]
            })
           }
           },
           {dataField:"categoria",visible:false},
           {dataField:"sottocategoria",visible:false},
          {
            dataField: "idS",
            caption: "Sottocategoria",
            alignment:allineamento,
            calculateDisplayValue: function(rowData) {
    return  rowData.sottocategoria},
            editCellTemplate: function(cellElement,cellInfo){
           if ($("#val_sottocategoria").length===0) {
                $('<div id="val_sottocategoria"></div>').appendTo(cellElement)
            }
            let valoriLista=[]
            if ($("#val_categoria").dxSelectBox("instance").option("value")){
                for (let cat of sottocategorie){
                    if ($("#val_categoria").dxSelectBox("instance").option("value")===cat.idCat){
                        valoriLista=[...valoriLista,cat]
                    }
                }
            }

            $("#val_sottocategoria").dxSelectBox({
                dataSource: valoriLista,
                valueExpr: 'ID', // Utilizza "id" per identificare un elemento
                displayExpr: 'name', // Mostra il "text" dell'elemento nella lista
                showClearButton: true,
                value:cellInfo.value,
                searchEnabled:true,
                onValueChanged: function(e) {
                cellInfo.setValue(e.value)},
                buttons: [{
                  name: 'modifica',
                  location: 'after',
                  options: {
                    width: 20,
                    template: function () {
                        return $("<i class='fa-solid fa-pencil'></i>");
                    },
                    onClick(e) {
                      if ($("#val_sottocategoria").dxSelectBox("instance").option("value")){
                      var indice=""
                      for (let i of sottocategorie){
                        if (i.ID===$("#val_sottocategoria").dxSelectBox("instance").option("value")) {indice = i.name}
                      }
                      modificaLista(sottocategorie,false,indice,false,cellInfo,"val_sottocategoria",cellElement)} else {
                      const message = `Seleziona un nome per poter modificare!`;
                        window.DevExpress.ui.notify({message,
                        position: {
                          my: 'center',
                          at: 'center',
                          of: '#gridContainerSpese',

                        },}, "error", 1000);
                      }
                    },
                  },
                },
                {
                  name: 'aggiungi',
                  location: 'after',
                  options: {
                    width: 20,
                    template: function () {
                        return $("<i class='fa-solid fa-plus'></i>");
                    },
                    onClick(e) {
                      modificaLista(categorie,true,0,false,cellInfo,"val_sottocategoria",cellElement)
                    },
                  },
                },
                {
                  name: 'elimina',
                  location: 'after',
                  options: {
                    width: 20,
                    template: function () {

                        return $("<i class='fa-solid fa-trash-can'></i>");
                    },
                    onClick(e) {
                      if ($("#val_sottocategoria").dxSelectBox("instance").option("value")){
                        var indice=0
                      var contatore=0
                      for (let i of categorie){
                        if (i===$("#val_sottocategoria").dxSelectBox("instance").option("value")) {indice = contatore}
                        contatore+=1
                      }
                      modificaLista(categorie,false,indice,true,cellInfo,"val_sottocategoria",cellElement)
                      } else
                      {
                        const message = `Seleziona un nome per poter eliminare!`;
                        window.DevExpress.ui.notify({message,
                        position: {
                          my: 'center',
                          at: 'center',
                          of: '#gridContainerSpese',

                        },}, "error", 1000);
                      }
                    },
                  },
                },
                ]
            })
           }
          },

          { dataField: "valore", alignment:allineamento,caption: "Importo spesa", hidingPriority:3,calculateDisplayValue: function(rowData) {
          let val=0
          if (rowData.valore)val=rowData.valore
    return  `${val.toLocaleString("it-IT", { maximumFractionDigits: 2 })} ${convertiValuta(rowData.valuta)}`},
  editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_importo").length===0) {
                $('<div id="val_importo"></div>').appendTo(cellElement)
            }
            $("#val_importo").dxNumberBox({min:0,value:cellInfo.value,format:`#0.##${convertiValuta(cellInfo.data.valuta)}`, onValueChanged: function(e) {

            cellInfo.setValue(e.value)
            }})
          },
  },
          { dataField: "valuta",visible:false, alignment:allineamento,caption: "Valuta spesa",hidingPriority:5,customizeText: function (e){
          return convertiValuta(e.value)},
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_valuta").length===0) {
                $('<div id="val_valuta"></div>').appendTo(cellElement)
            }
            let dati_ut=[]
              let inizio=0
              while (convertiValuta(inizio)){
                dati_ut.push({id:inizio,name:convertiValuta(inizio)})
                  inizio+=1
              }
            $("#val_valuta").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            $("#val_importo").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
            }})
          },
        },
        { dataField: "note", alignment:allineamento,caption: "Note spesa",hidingPriority:5,
        },

          {
            type: "buttons",
            minWidth:120,
            buttons: [
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
            ],
          },
          ],
          showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "100vh",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },
        editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            title: "Modifica spesa",
            showTitle: true,
            width:"80%",
            height:"auto",
            maxHeight:"90%",
            onShown: function(e) {
                const $content = $(e.component.content());
                $content.wrapInner('<div id="customScroll" style="height: 100%; max"></div>');
                $("#customScroll").dxScrollView({
                    useNative: true,
                    direction: "vertical",
                    showScrollbar: "onScroll"
                });
                }
            },
          form: {
  colCount: 1,  // Tutti gli elementi a tutta larghezza
  items: [
    {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                "data","idC","idS","valore","valuta","note"
                ],
              },
  ],
}

        },
        onCellClick: function(e) {
            if (e.event.target && e.event.target.classList.contains("dx-datagrid-adaptive-more")) {
              const masterRow = e.component.getRowElement(e.row.rowIndex);
              const $icon = masterRow.find(".dx-datagrid-adaptive-more.custom-icon-expanded");
              if (!($icon.length)) {
              const masterRow = e.component.getRowElement(e.row.rowIndex);
              const $icon = masterRow.find(".dx-datagrid-adaptive-more");
              if ($icon.length){
              $icon[0].className = "dx-datagrid-adaptive-more custom-icon-expanded";}
              }
              else
              {
              $icon[0].className = "dx-datagrid-adaptive-more";
              }}

        },
        onEditorPreparing: function(e) {
          if (e.parentType === "filterRow" && (e.dataField === "data"||e.dataField === "storageDa"||e.dataField==="storageA")) {

            e.editorName = "dxDateBox";  // Forza DateBox come filtro
            e.editorOptions = {
              displayFormat: "dd/MM/yyyy",
              type: "date",
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);  // Applica il filtro
              }
            };
          }
          if (e.parentType === "filterRow" && e.dataField === "idC") {
            e.editorName = "dxSelectBox";  // Forza DateBox come filtro
            e.editorOptions = {
              dataSource:categorie,valueExpr: 'ID',displayExpr: 'name',searchEnabled: true,
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);  // Applica il filtro
              }
            };
          }
          if (e.parentType === "filterRow" && e.dataField === "idS") {
            e.editorName = "dxSelectBox";  // Forza DateBox come filtro
            e.editorOptions = {
              dataSource:sottocategorie,valueExpr: 'ID',displayExpr: 'name',searchEnabled: true,
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);  // Applica il filtro
              }
            };
          }
        },
        onInitNewRow: function (e) {
        modificheCategorie = {
  aggiunti: [],
  eliminati: [],
  modificati: [],
};
 modificheSottoCategorie = {
  aggiunti: [],
  eliminati: [],
  modificati: [],
};
        },
        onRowInserting: async function (e) {
            const gridElement = $("#gridContainerSpese"); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
            let lux=null
            if (!(e.data.data instanceof Date))
            lux=DateTime.fromISO(e.data.data)
            else
            lux=DateTime.fromJSDate(e.data.data)
            let dati_n={"transactionambit":0,"transactioncategory":0,'transactionvalue':e.data.valore,"registrysubtypeid":e.data.idS,"transactionnotes":e.data.note,'transactioncurrency':e.data.valuta,'transactiondate':lux.toFormat("yyyyMMdd"),'transactionnotes':e.data.note};
            let richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:e.data.id,
                valori:dati_n,
                azione:'setTransaction'})
            for (let modificato of modificheCategorie["modificati"]){
            dati_n={'registrytypedescr':modificato.name}
                richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:modificato.ID,
                valori:dati_n,
                azione:'setRegistryType'})
            }
            for (let modificato of modificheCategorie["eliminati"]){
                richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                delId:modificato.ID,
                azione:'delRegistryType'})
            }
            for (let modificato of modificheSottoCategorie["modificati"]){
            dati_n={'registrysubtypedescr':modificato.name}
                richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:modificato.ID,
                valori:dati_n,
                azione:'setRegistrySubType'})}
            for (let modificato of modificheSottoCategorie["eliminati"]){
                richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                delId:modificato.ID,
                azione:'detRegistrySubType'})
            }
            for (let modificato of modificheSottoCategorie["aggiunti"]){
            dati_n={"registrytypeid":modificato.ID,"registrysubtypedescr":modificato.name}
                richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                valori:dati_n,
                azione:'setRegistrySubType'})
            }
            for (let modificato of modificheSottoCategorie["eliminati"]){
                richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                delId:modificato.ID,
                azione:'delRegistrySubType'})
            }
                if (richiesta) {
                window.location.reload()

                }

        },
        onRowUpdated: async function (e) {
            const gridElement = $("#gridContainerSpese"); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
            //const nomiLista=e.data.nomi
            let lux=null
            if (!(e.data.data instanceof Date))
            lux=DateTime.fromISO(e.data.data)
            else
            lux=DateTime.fromJSDate(e.data.data)
            let dati_n={'transactionvalue':e.data.valore,"registrysubtypeid":e.data.idS,"transactionnotes":e.data.note,'transactioncurrency':e.data.valuta,'transactiondate':lux.toFormat("yyyyMMdd"),'transactionnotes':e.data.note};
            let richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:e.data.id,
                valori:dati_n,
                azione:'setTransaction'})
            for (let modificato of modificheCategorie["modificati"]){
            dati_n={'registrytypedescr':modificato.name}
                richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:modificato.ID,
                valori:dati_n,
                azione:'setRegistryType'})
            }
            for (let modificato of modificheCategorie["aggiunti"]){
            dati_n={"registrytypecategory":1,'registrytypedescr':modificato.name}
                richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                valori:dati_n,
                azione:'setRegistryType'})
            }

            for (let modificato of modificheCategorie["eliminati"]){
            console.log(modificato.ID)
                richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                delId: modificato.ID,
                azione:'delRegistryType'})
            }
            for (let modificato of modificheSottoCategorie["modificati"]){
            dati_n={'registrysubtypedescr':modificato.name}
                richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:modificato.ID,
                valori:dati_n,
                azione:'setRegistrySubType'})
            }
            for (let modificato of modificheSottoCategorie["aggiunti"]){
            dati_n={"registrytypeid":modificato.ID,"registrysubtypedescr":modificato.name}
                richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                valori:dati_n,
                azione:'setRegistrySubType'})
            }
            for (let modificato of modificheSottoCategorie["eliminati"]){
                richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                delId:modificato.ID,
                azione:'delRegistrySubType'})
            }
                if (richiesta) {
                const message = `Spesa modificata con successo`;

                window.DevExpress.ui.notify({message,
                        position: {
                          my: 'center',
                          at: 'center',
                          of: '#gridContainerSpese',

                        },}, "success", 500);
                }
            },
        onRowRemoving: async function (e) {
            const richiesta=  await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                delId:e.data.id,
                azione:'delTransaction',
                return_data:false})
            if (richiesta) {
                const message = `Spesa eliminata con successo`;
                window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerSpese',

                },}, "success", 500);}
        },
onEditingStart: function(e) {
     modificheCategorie = {
  aggiunti: [],
  eliminati: [],
  modificati: [],
};
 modificheSottoCategorie = {
  aggiunti: [],
  eliminati: [],
  modificati: [],
};
  },
        onRowPrepared: function (e) {
            setTimeout(() => {
                $("#gridContainerSpese").removeClass("grid-container-hidden");
                $("#loadingOverlay").hide();},500)

        },
          })
          $("#modificaListaNomi").dxPopup({
    width: "60%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,

    onShown: function(e) {
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScrollLista" style="height: 100%;"></div>');
    $("#customScrollLista").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
    },
    });
    $("#modificaListaNomi").dxPopup({
    width: "60%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,

    onShown: function(e) {
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScrollLista" style="height: 100%;"></div>');
    $("#customScrollLista").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
    },
    });

        }
        fetchStorages()
    },[])
return (<div id="gridContainerSpese" ></div>)
}

return (<div>
        <TabellaStoricoSpese/>
        <div id="modificaListaNomi"/>
        <div id="loadingOverlay">
           <div className="spinner">
              <Lottie  style={{ width: "30%", height: "30%" }} animationData={animLoading} loop={true} />
           </div>
        </div>
        </div>)
}

export default SpeseStorico